import Common from '../../../../Common';

export interface FlowConnector {
	id: id
	src_pbx_dad_flow_item_id: id
	dst_pbx_dad_flow_item_id: id
	value: string | null
}

interface Body {
	src_pbx_dad_flow_item_id: id
	dst_pbx_dad_flow_item_id: id
	value: id | null
}

interface UpdateBody {
	value: id | null
}

const Connector = class extends Common {
	browse = (companyId: id, id: id): CustomResponse<FlowConnector[]> =>
		this.get(`/company/${companyId}/pbxdad/flow/${id}/connector`)

	create = (companyId: id, id: id, body: Body): CustomResponse<FlowConnector> =>
		this.post(`/company/${companyId}/pbxdad/flow/${id}/connector`, body)

	update = (companyId: id, id: id, connectorId: id, body: UpdateBody): CustomResponse<FlowConnector> =>
		this.patch(`/company/${companyId}/pbxdad/flow/${id}/connector/${connectorId}`, body)

	delete = (companyId: id, id: id, connectorId: id) =>
		this.doDelete(`/company/${companyId}/pbxdad/flow/${id}/connector/${connectorId}`)
}

export default Connector
